import { DataTableRef } from "../../common/components/DataTable";
import { Infraccion } from "../../infracciones/hooks/useInfraccionesAPI";
import { useEffect, useRef, useState } from "react";
import useConveniosPagoAPI from "../useConveniosPagoAPI";
import InfraccionesInfractorTable from "./InfraccionesInfractorTable";

export interface InfraccionesConvenioListProps {
    CuitCuil: string
    onInfraccionesSelectionChanged?: (infracciones: Infraccion[]) => any
    mostrarVigentes: boolean
    setSelectedInfraccionesIds?: any
    /*selectedInfracciones?: Infraccion[]*/
}

export default (props: InfraccionesConvenioListProps) => {
    const api = useConveniosPagoAPI()
    const dataTableRef = useRef<DataTableRef>(undefined!);
    const [data, setData] = useState<Infraccion[]>([]);

    useEffect( () => {
        //dataTableRef.current.loadItems();
        api.listInfraccionesCuitCuil({}, props.CuitCuil, props.mostrarVigentes).then(result => {
            if (!result.error && result.data) {
                setData(result?.data.value ?? []);
            }
        });
    }, [props.CuitCuil, props.mostrarVigentes])

    return (
        <InfraccionesInfractorTable
            //ref={dataTableRef}
            onInfraccionesSelectionChanged={props.onInfraccionesSelectionChanged}
            list={(query) => api.listInfraccionesCuitCuil({ ...query, ...{} }, props.CuitCuil, props.mostrarVigentes)}
            title={"Infracciones adeudadas" + (props.mostrarVigentes?' y vigentes.':' y vencidas')}
            sourceData={data}
            setSelectedInfraccionesIds={props.setSelectedInfraccionesIds}
        />
    )
}


